import React, { Suspense, lazy, useMemo } from 'react';
import { isPreviewAllowed } from './previewHosts';

const Microlink = lazy(() => import('@microlink/react'));

function extractUrls(htmlString) {
  const urlPattern = /href="(https?:\/\/[^\s"<>]+)"/g;
  const urls = [];
  let match;
  while ((match = urlPattern.exec(htmlString)) !== null) {
    urls.push(match[1]);
  }
  return urls;
}

function MessageMicrolinks({ html }) {
  // Only hosts on the allow-list are sent to the preview service; see previewHosts.js.
  const urls = useMemo(
    () => extractUrls(html || '').filter((url) => isPreviewAllowed(url)),
    [html]
  );

  if (!urls.length) return null;

  return (
    <Suspense fallback={null}>
      {urls.map((url) => (
        <div key={url} className="w-full max-w-full break-words pt-2">
          <Microlink
            url={url}
            direction="rtl"
            media="logo"
            size="small"
            style={{ width: '100%' }}
          />
        </div>
      ))}
    </Suspense>
  );
}

export default MessageMicrolinks;
